import { DtoCoDocumentoCobrar } from "src/app/erp/comercial/codocumento/dominio/DtoCoDocumentoCobrar";

export class DtoLineaCredito {
    lineaCreditoMoneda: string;
    lineaCreditoMonedaDescripcion: string;
    lineaCredito: number;
    busqueda: string;
    documentoFiscal: string;
    persona: number;
    lineaCreditoFechaVencimiento: Date;
    clasificacion: string;

    documentos: DtoCoDocumentoCobrar[];

    constructor() {
        this.documentos = [];
    }


    lineaCreditoLoMonto10: number;
    lineaCreditoExMonto09: number;

    montoUtilizadoLoMonto03: number;
    montoUtilizadoExMonto01: number;

    montoAprobarLoMonto04: number;
    montoAprobarExMonto02: number;

    disponibleLo: number;
    disponibleEx: number;

    
}